if (!customElements.get('momo-home-carousel')) {
  customElements.define('momo-home-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2 || this.events) return;
      this.events = new AbortController();
      const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: this.events.signal });
      this.index = 0;
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.toggle = this.querySelector('[data-toggle]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovered = false;
      this.visible = true;
      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-next]').hidden = false;
      listen(this.querySelector('[data-previous]'), 'click', () => this.show(this.index - 1, true));
      listen(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1, true));
      this.dots.forEach((dot, index) => listen(dot, 'click', () => this.show(index, true)));
      if (this.toggle) listen(this.toggle, 'click', () => {
        this.paused = !this.paused;
        this.updateToggle();
        this.schedule();
      });
      listen(this, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      listen(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => this.schedule());
      listen(this, 'focusout', () => queueMicrotask(() => this.schedule()));
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.updateToggle(); this.schedule(); });
      listen(this, 'keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
        event.preventDefault();
        const activeWasSlide = this.slides[this.index].contains(document.activeElement);
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        if (activeWasSlide) this.dots[this.index].focus();
      });
      listen(this, 'pointerdown', (event) => {
        this.touchStart = event.pointerType === 'touch' && event.target.closest('.momo-carousel__media') ? { x: event.clientX, y: event.clientY } : null;
      }, { passive: true });
      listen(this, 'pointerup', (event) => {
        if (!this.touchStart) return;
        const dx = event.clientX - this.touchStart.x;
        const dy = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
      listen(this, 'pointercancel', () => { this.touchStart = null; });
      listen(this, 'shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.show(index, true);
      });
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.schedule(); });
      this.observer.observe(this);
      this.updateToggle();
      this.schedule();
    }
    show(index, manual = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
        if (active) this.dots[i].setAttribute('aria-current', 'true');
        else this.dots[i].removeAttribute('aria-current');
      });
      if (manual) {
        this.paused = true;
        this.updateToggle();
        this.querySelector('[data-status]').textContent = this.slides[this.index].getAttribute('aria-label');
      }
      this.schedule();
    }
    updateToggle() {
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      this.toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
      this.toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.paused || this.hovered || !this.visible || document.hidden || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.events?.abort();
      this.events = null;
    }
  });
}
